// THEME

import {
  getLocalStorageItem,
  removeLocalStorageItem,
  setLocalStorageItem,
} from '../../../utils/local-storage'

export type ThemeNames = 'dark' | 'light' | 'auto'

// TODO: Leverage useContext to support re-renders on theme change
// https://react.dev/reference/react/useContext#optimizing-re-renders-when-passing-objects-and-functions

export const initializeTheme = () => {
  loadTheme()
  'matchMedia' in window &&
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', loadTheme)
}

export const loadTheme = () => {
  const storedTheme = getLocalStorageItem('theme')
  if (storedTheme) {
    document.documentElement.setAttribute('data-bs-theme', storedTheme)
  } else {
    document.documentElement.setAttribute(
      'data-bs-theme',

      'matchMedia' in window && window.matchMedia('(prefers-color-scheme: dark)').matches
        ? 'dark'
        : 'light',
    )
  }
}

export const setTheme = (newTheme: ThemeNames) => {
  if (newTheme === 'auto') {
    removeLocalStorageItem('theme')
  } else {
    setLocalStorageItem('theme', newTheme)
  }
  loadTheme()
}

export const getTheme = (): ThemeNames => {
  return getLocalStorageItem('theme') || 'auto'
}

export const isDarkMode = () => {
  const theme = getLocalStorageItem('theme')
  if (theme === 'light') {
    return false
  }
  return (
    theme === 'dark' ||
    ('matchMedia' in window && window.matchMedia('(prefers-color-scheme: dark)').matches)
  )
}
